/** `catalog` module DTOs keys */
export enum CatalogDtosKeysEnum {
  /** Accounting account dimensions setting response body */
  ACCOUNT_DIMENSION_SETTING_FIND_DTO = 'catalog/account-dimension-setting-find.dto',
  /** Account dimension detting selection settings */
  ACCOUNT_DIMENSION_SETTING_SELECT_DTO = 'catalog/account-dimension-setting-select.dto',
  /** Account dimension detting sorting settings */
  ACCOUNT_DIMENSION_SETTING_SORT_DTO = 'catalog/account-dimension-setting-sort.dto',
  /** Account dimension detting find many API query parameters */
  ACCOUNT_DIMENSION_SETTING_FIND_MANY_QUERY_DTO = 'catalog/account-dimension-setting-find-many-query.dto',
  /** Account dimension detting find many API response body */
  ACCOUNT_DIMENSION_SETTING_PAGE_DTO = 'catalog/account-dimension-setting-page.dto',
  /** Account dimension detting find one API query parameters */
  ACCOUNT_DIMENSION_SETTING_FIND_ONE_QUERY_DTO = 'catalog/account-dimension-setting-find-one-query.dto',
  /** Account dimension detting own filters */
  ACCOUNT_DIMENSION_SETTING_FILTERS_DTO = 'catalog/account-dimension-setting-filters.dto',
  /** Accounting account filters query parameters */
  ACCOUNTING_ACCOUNT_FILTERS_DTO = 'catalog/accounting-account-filters.dto',
  /** Accounting account response body */
  ACCOUNTING_ACCOUNT_FIND_DTO = 'catalog/accounting-account-find.dto',
  /** Accounting accounts list API response body */
  ACCOUNTING_ACCOUNT_PAGE_DTO = 'catalog/accounting-account-page.dto',
  /** Accounting account list API query parameters */
  ACCOUNTING_ACCOUNT_QUERY_DTO = 'catalog/accounting-account-query.dto',
  /** Accounting account registry column selection parameters */
  ACCOUNTING_ACCOUNT_SELECT_DTO = 'catalog/accounting-account-select.dto',
  /** Accounting account registry sorting settings */
  ACCOUNTING_ACCOUNT_SORT_DTO = 'catalog/accounting-account-sort.dto',
  /** Budget classification code list API base filters */
  BUDGET_CLASSIFICATION_CODE_FILTERS_DTO = 'catalog/budget-classification-code-filters.dto',
  /** Budget classification code find many API query parameters */
  BUDGET_CLASSIFICATION_CODE_FIND_MANY_QUERY_DTO = 'catalog/budget-classification-code-find-many-query.dto',
  /** Budget classification code find one API query parameters */
  BUDGET_CLASSIFICATION_CODE_FIND_ONE_QUERY_DTO = 'catalog/budget-classification-code-find-one-query.dto',
  /** Budget classification code response body */
  BUDGET_CLASSIFICATION_CODE_FIND_DTO = 'catalog/budget-classification-code-find.dto',
  /** Budget classification code create and update APIs request body */
  BUDGET_CLASSIFICATION_CODE_FORM_DTO = 'catalog/budget-classification-code-form.dto',
  /** Budget classification code page response body */
  BUDGET_CLASSIFICATION_CODE_PAGE_DTO = 'catalog/budget-classification-code-page.dto',
  /** Budget revenue admin list API base filters */
  BUDGET_REVENUE_ADMIN_FILTERS_DTO = 'catalog/budget-revenue-admin-filters.dto',
  /** Budget revenue admin find many API query parameters */
  BUDGET_REVENUE_ADMIN_FIND_MANY_QUERY_DTO = 'catalog/budget-revenue-admin-find-many-query.dto',
  /** Budget revenue admin find one API query parameters */
  BUDGET_REVENUE_ADMIN_FIND_ONE_QUERY_DTO = 'catalog/budget-revenue-admin-find-one-query.dto',
  /** Budget revenue admin response body */
  BUDGET_REVENUE_ADMIN_FIND_DTO = 'catalog/budget-revenue-admin-find.dto',
  /** Budget revenue admin create and update APIs request body */
  BUDGET_REVENUE_ADMIN_FORM_DTO = 'catalog/budget-revenue-admin-form.dto',
  /** Budget revenue admins page response body */
  BUDGET_REVENUE_ADMIN_PAGE_DTO = 'catalog/budget-revenue-admin-page.dto',
  /** Const center find one API additional options (query parameters) */
  COST_CENTER_FIND_ONE_OPTIONS_DTO = 'catalog/cost-center-find-one-options.dto',
  /** Cost center response body */
  COST_CENTER_FIND_DTO = 'catalog/cost-center-find.dto',
  /** Cost center create/update request body */
  COST_CENTER_FORM_DTO = 'catalog/cost-center-form.dto',
  /** Cost centers list page response body */
  COST_CENTER_PAGE_DTO = 'catalog/cost-center-page.dto',
  /** Cost center list API query parameters */
  COST_CENTER_QUERY_DTO = 'catalog/cost-center-query.dto',
  /** Cost center registry column selection parameters */
  COST_CENTER_SELECT_DTO = 'catalog/cost-center-select.dto',
  /** Cost center registry sorting settings */
  COST_CENTER_SORT_DTO = 'catalog/cost-center-sort.dto',
  /** Cost center registry items page response body */
  COST_CENTER_ITEMS_PAGE_DTO = 'catalog/cost-center-items-page.dto',
  /** Currency find many API query parameters (settings and filters) */
  CURRENCY_FIND_MANY_QUERY_DTO = 'catalog/currency-find-many-query.dto',
  /** Currency find one API query parameters (additional options) */
  CURRENCY_FIND_ONE_QUERY_DTO = 'catalog/currency-find-one-query.dto',
  /** Currency response body */
  CURRENCY_FIND_DTO = 'catalog/currency-find.dto',
  /** Currency create and update APIs request body */
  CURRENCY_FORM_DTO = 'catalog/currency-form.dto',
  /** Currencies list API page response body */
  CURRENCY_PAGE_DTO = 'catalog/currency-page.dto',
  /** Currency rate list APIs base filters */
  CURRENCY_RATE_FILTERS_DTO = 'catalog/currency-rate-filters.dto',
  /** Currency rate find many API query parameters */
  CURRENCY_RATE_FIND_MANY_QUERY_DTO = 'catalog/currency-rate-find-many-query.dto',
  /** Currency rate find one API query parameters */
  CURRENCY_RATE_FIND_ONE_QUERY_DTO = 'catalog/currency-rate-find-one-query.dto',
  /** Currency rate response body */
  CURRENCY_RATE_FIND_DTO = 'catalog/currency-rate-find.dto',
  /** Currency rate create and update APIs request body */
  CURRENCY_RATE_FORM_DTO = 'catalog/currency-rate-form.dto',
  /** Currency rate find many API response body */
  CURRENCY_RATE_PAGE_DTO = 'catalog/currency-rate-page.dto',
  /** Currency rate single APIs URL parameters */
  CURRENCY_RATE_PARAMS_DTO = 'catalog/currency-rate-params.dto',
  /** Add user to direction API request body */
  DIRECTION_ADD_USER_FORM_DTO = 'catalog/direction-add-user-form.dto',
  /** Add user group to direction API request body */
  DIRECTION_ADD_USER_GROUP_FORM_DTO = 'catalog/direction-add-user-group-form.dto',
  /** Direction balance sheet settings response body */
  DIRECTION_BALANCE_SHEET_SETTINGS_FIND_DTO = 'catalog/direction-balance-sheet-settings-find.dto',
  /** Direction balance sheet settings create/update request body */
  DIRECTION_BALANCE_SHEET_SETTINGS_FORM_DTO = 'catalog/direction-balance-sheet-settings-form.dto',
  /** Direction bulk assign financial classification request body */
  DIRECTION_BULK_ASSIGN_FINANCIAL_CLASSIFICATION_DTO = 'catalog/direction-bulk-assign-financial-classification.dto',
  /** Direction category response body */
  DIRECTION_CATEGORY_FIND_DTO = 'catalog/direction-category-find.dto',
  /** Direction financial classification request and response common body */
  DIRECTION_FINANCIAL_CLASSIFICATION_DTO = 'cataog/direction-financial-classification.dto',
  /** Direction response body */
  DIRECTION_FIND_DTO = 'catalog/direction-find.dto',
  /** Direction create/update request body */
  DIRECTION_FORM_DTO = 'catalog/direction-form.dto',
  /** Directions' group create/update request body */
  DIRECTION_GROUP_FORM_DTO = 'catalog/direction-group-form.dto',
  /** Directions list and tree APIs query parameters */
  DIRECTION_QUERY_DTO = 'catalog/direction-query.dto',
  /** Direction registry API query parameters */
  DIRECTION_REGISTRY_QUERY_DTO = 'catalog/direction-registry-query.dto',
  /** Direction registry API filter parameters */
  DIRECTION_REGISTRY_FILTERS_DTO = 'catalog/direction-registry-filters.dto',
  /** Direction registry selectable item */
  DIRECTION_REGISTRY_SELECTABLE_ITEM_DTO = 'catalog/direction-registry-selectable-item.dto',
  /** Direction registry column selection parameters */
  DIRECTION_SELECT_DTO = 'catalog/direction-select.dto',
  /** Direction registry items page */
  DIRECTION_ITEMS_PAGE_DTO = 'catalog/direction-items-page.dto',
  /** Directions reorder API request body */
  DIRECTIONS_REORDER_DTO = 'catalog/directions-reorder.dto',
  /** Filial find many API query parameters */
  FILIAL_FIND_MANY_QUERY_DTO = 'catalog/filial-find-many-query.dto',
  /** Filial find one API query parameters */
  FILIAL_FIND_ONE_QUERY_DTO = 'catalog/filial-find-one-query.dto',
  /** Filial find one API response body */
  FILIAL_FIND_DTO = 'catalog/filial-find.dto',
  /** Filial create/update APIs request body */
  FILIAL_FORM_DTO = 'catalog/filial-form.dto',
  /** Filial registry column selection parameters */
  FILIAL_SELECT_DTO = 'catalog/filial-select.dto',
  /** Filial registry sorting settings */
  FILIAL_SORT_DTO = 'catalog/filial-sort.dto',
  /** Filial registry items page */
  FILIAL_ITEMS_PAGE_DTO = 'catalog/filial-items-page.dto',
  /** Unit find many API query parameters */
  UNIT_FIND_MANY_QUERY_DTO = 'catalog/unit-find-many-query.dto',
  /** Unit find one API query parameters */
  UNIT_FIND_ONE_QUERY_DTO = 'catalog/unit-find-one-query.dto',
  /** Unit create and update APIs request body */
  UNIT_FORM_DTO = 'catalog/unit-form.dto',
  /** Single unit response body */
  UNIT_FIND_DTO = 'catalog/unit-find.dto',
  /** Unit registry column selection parameters */
  UNIT_SELECT_DTO = 'catalog/unit-select.dto',
  /** Unit registry sorting settings */
  UNIT_SORT_DTO = 'catalog/unit-sort.dto',
  /** Unit registry items page */
  UNIT_ITEMS_PAGE_DTO = 'catalog/unit-items-page.dto',
  /** Unit registry selectable item */
  MASTER_MILESTONE_HISTORY_FIND_DTO = 'catalog/master-milestone-history-find.dto',
  MASTER_MILESTONE_HISTORY_PAGE_DTO = 'catalog/master-milestone-history-page.dto',
  /** Approval scheme list API query parameters */
  APPROVAL_SCHEME_QUERY_DTO = 'catalog/approval-scheme-query.dto',
  /** Approval scheme own filters */
  APPROVAL_SCHEME_FILTERS_DTO = 'catalog/approval-scheme-filters.dto',
  /** Approval scheme find one API query parameters */
  APPROVAL_SCHEME_FIND_ONE_QUERY_DTO = 'catalog/approval-scheme-find-one-query.dto',
  APPROVAL_SCHEME_FIND_DTO = 'catalog/approval-scheme-find.dto',
  APPROVAL_SCHEME_FORM_DTO = 'catalog/approval-scheme-form.dto',
  /** Approval scheme partial update API request body */
  APPROVAL_SCHEME_PARTIAL_FORM_DTO = 'catalog/approval-scheme-partial-form.dto',
  APPROVAL_SCHEME_HISTORY_FIND_DTO = 'catalog/approval-scheme-history-find.dto',
  APPROVAL_SCHEME_HISTORY_PAGE_DTO = 'catalog/approval-scheme-history-page.dto',
  /** Approval scheme registry column selection parameters */
  APPROVAL_SCHEME_SELECT_DTO = 'catalog/approval-scheme-select.dto',
  /** Approval scheme registry sorting settings */
  APPROVAL_SCHEME_SORT_DTO = 'catalog/approval-scheme-sort.dto',
  /** Approval scheme registry items page */
  APPROVAL_SCHEME_ITEMS_PAGE_DTO = 'catalog/approval-scheme-items-page.dto',
  BANK_FIND_DTO = 'catalog/bank-find.dto',
  /** Nomenclature item and group response body common fields */
  NOMENCLATURE_BASE_FIND_DTO = 'catalog/nomenclature-base-find.dto',
  /** Nomenclature item and group create and update request body common fields */
  NOMENCLATURE_BASE_FORM_DTO = 'catalog/nomenclature-base-form.dto',
  /** Nomenclature group response body */
  NOMENCLATURE_GROUP_FIND_DTO = 'catalog/nomenclature-group-find.dto',
  /** Nomenclature group create and update request body */
  NOMENCLATURE_GROUP_FORM_DTO = 'catalog/nomenclature-group-form.dto',
  /** Nomenclature item response body */
  NOMENCLATURE_ITEM_FIND_DTO = 'catalog/nomenclature-item-find.dto',
  /** Nomenclature item create and update request body */
  NOMENCLATURE_ITEM_FORM_DTO = 'catalog/nomenclature-item-form.dto',
  /** Nomenclature item list API query parameters */
  NOMENCLATURE_ITEM_QUERY_DTO = 'catalog/nomenclature-item-query.dto',
  /** Nomenclature item list API extra filters */
  NOMENCLATURE_ITEM_LIST_FILTERS_DTO = 'catalog/nomenclature-item-list-filters.dto',
  /** Nomenclature items list page response body */
  NOMENCLATURE_ITEM_PAGE_DTO = 'catalog/nomenclature-item-page.dto',
  /** Nomenclature mixed items and groups tree node response body  */
  NOMENCLATURE_TREE_FIND_DTO = 'catalog/nomenclature-tree-find.dto',
  /** Nomenclature mixed items and groups tree API query parameters */
  NOMENCLATURE_TREE_QUERY_DTO = 'catalog/nomenclature-tree-query.dto',
  /** Nomenclature hierarchy registry selectable item */
  NOMENCLATURE_HIERARCHY_REGISTRY_SELECTABLE_ITEM_DTO = 'catalog/nomenclature-hierarchy-registry-selectable-item.dto',
  /** Nomenclature flat registry selectable item */
  NOMENCLATURE_FLAT_REGISTRY_SELECTABLE_ITEM_DTO = 'catalog/nomenclature-flat-registry-selectable-item.dto',
  /** Nomenclature registry column selection parameters */
  NOMENCLATURE_SELECT_DTO = 'catalog/nomenclature-select.dto',
  /** Nomenclature registry sorting settings */
  NOMENCLATURE_SORT_DTO = 'catalog/nomenclature-sort.dto',
  /** Nomenclature registry API query parameters */
  NOMENCLATURE_REGISTRY_QUERY_DTO = 'catalog/nomenclature-registry-query.dto',
  /** Nomenclature registry items page */
  NOMENCLATURE_ITEMS_PAGE_DTO = 'catalog/nomenclature-items-page.dto',
  /** Nomenclature group list API query parameters */
  NOMENCLATURE_GROUP_QUERY_DTO = 'catalog/nomenclature-group-query.dto',
  /** Payer status list APIs base filters */
  PAYER_STATUS_FILTERS_DTO = 'catalog/payer-status-filters.dto',
  /** Payer status find many API query parameters */
  PAYER_STATUS_FIND_MANY_QUERY_DTO = 'catalog/payer-status-find-many-query.dto',
  /** Payer status find one API additional query parameters */
  PAYER_STATUS_FIND_ONE_QUERY_DTO = 'catalog/payer-status-find-one-query.dto',
  /** Payer status response body */
  PAYER_STATUS_FIND_DTO = 'catalog/payer-status-find.dto',
  /** Payer status create and update APIs request body */
  PAYER_STATUS_FORM_DTO = 'catalog/payer-status-form.dto',
  /** Payer statuses page response body */
  PAYER_STATUS_PAGE_DTO = 'catalog/payer-status-page.dto',
  NOMENCLATURE_FIND_DTO = 'catalog/nomenclature-find.dto',
  NOMENCLATURE_FORM_DTO = 'catalog/nomenclature-form.dto',
  NOMENCLATURE_QUERY_DTO = 'catalog/nomenclature-query.dto',
  /** Master milestone find many API query parameters */
  MASTER_MILESTONE_FIND_MANY_QUERY_DTO = 'catalog/master-milestone-find-many-query.dto',
  /** Master milestone find one API query parameters */
  MASTER_MILESTONE_FIND_ONE_QUERY_DTO = 'catalog/master-milestone-find-one-query.dto',
  MASTER_MILESTONE_FIND_DTO = 'catalog/master-milestone-find.dto',
  MASTER_MILESTONE_FORM_DTO = 'catalog/master-milestone-form.dto',
  /** Master milestone registry column selection parameters */
  MASTER_MILESTONE_SELECT_DTO = 'catalog/master-milestone-select.dto',
  /** Master milestone registry sorting settings */
  MASTER_MILESTONE_SORT_DTO = 'catalog/master-milestone-sort.dto',
  /** Master milestone registry items page */
  MASTER_MILESTONE_ITEMS_PAGE_DTO = 'catalog/master-milestone-items-page.dto',
  COPY_REFERENCE_QUERY_DTO = 'catalog/copy-reference-query.dto',
  REFERENCE_FIND_DTO = 'catalog/reference-find.dto',
  REFERENCE_FORM_DTO = 'catalog/reference-form.dto',
  /** Room response body */
  ROOM_FIND_DTO = 'catalog/room-find.dto',
  /** Rooms flat list API query parameters */
  ROOM_FLAT_LIST_QUERY_DTO = 'catalog/room-flat-list-query.dto',
  /** Rooms personal account API query parameters */
  ROOM_PERSONAL_ACCOUNT_QUERY_DTO = 'catalog/room-personal-account-query.dto',
  /** Room create/update request body */
  ROOM_FORM_DTO = 'catalog/room-form.dto',
  /** Rooms list with pagination API query parameters */
  ROOM_PAGE_QUERY_DTO = 'catalog/room-page-query.dto',
  /** Rooms list with pagination API response body */
  ROOM_PAGE_DTO = 'catalog/room-page.dto',
  /** Room registry subtotals API response (aggregates for filtered list) */
  ROOM_REGISTRY_SUBTOTALS_DTO = 'catalog/room-registry-subtotals.dto',
  /** Room registry subtotal metric (count and area) */
  ROOM_REGISTRY_SUBTOTAL_METRIC_DTO = 'catalog/room-registry-subtotal-metric.dto',
  /** One display row in room registry subtotals */
  ROOM_REGISTRY_SUBTOTAL_DISPLAY_ROW_DTO = 'catalog/room-registry-subtotal-display-row.dto',
  /** Room registry subtotals response: grand totals block */
  ROOM_REGISTRY_SUBTOTALS_TOTALS_DTO = 'catalog/room-registry-subtotals-totals.dto',
  /** Room partial update API request body */
  ROOM_PARTIAL_UPDATE_DTO = 'catalog/room-partial-update.dto',
  /** Room registry API query parameters */
  ROOM_REGISTRY_QUERY_DTO = 'catalog/room-registry-query.dto',
  /** Room registry column selection parameters */
  ROOM_SELECT_DTO = 'catalog/room-select.dto',
  /** Room registry sorting settings */
  ROOM_SORT_DTO = 'catalog/room-sort.dto',
  /** Room registry items page */
  ROOM_ITEMS_PAGE_DTO = 'catalog/room-items-page.dto',
  /** Room registry selectable item */
  ROOM_REGISTRY_SELECTABLE_ITEM_DTO = 'catalog/room-registry-selectable-item.dto',
  /** Room registry API filter parameters */
  ROOM_FILTERS_DTO = 'catalog/room-filters.dto',
  /** Room registry subtotal API own settings */
  ROOM_SUBTOTAL_SETTINGS_DTO = 'catalog/room-subtotal-settings.dto',
  /** Room registry subtotal API query parameters */
  ROOM_SUBTOTAL_QUERY_DTO = 'catalog/room-subtotal-query.dto',
  /** Room registry subtotal API response body */
  ROOM_SUBTOTAL_DTO = 'catalog/room-subtotal.dto',
  /** Required analytical features common request and response body */
  REQUIRED_ANALYTICAL_FEATURES_DTO = 'catalog/required-analytical-features.dto',
  /** 1C ERP native operation type list API filters */
  ERP_1C_OPERATION_TYPE_FILTERS_DTO = 'catalog/erp-1c-operation-type-filters.dto',
  /** 1C ERP native operation type find many API query parameters */
  ERP_1C_OPERATION_TYPE_FIND_MANY_QUERY_DTO = 'catalog/erp-1c-operation-type-find-many-query.dto',
  /** 1C ERP native operation type find one API query parameters */
  ERP_1C_OPERATION_TYPE_FIND_ONE_QUERY_DTO = 'catalog/erp-1c-operation-type-find-one-query.dto',
  /** 1C ERP native operation type response body */
  ERP_1C_OPERATION_TYPE_FIND_DTO = 'catalog/erp-1c-operation-type-find.dto',
  /** 1C ERP native operation type create and update APIs request body */
  ERP_1C_OPERATION_TYPE_FORM_DTO = 'catalog/erp-1c-operation-type-form.dto',
  /** 1C ERP native operation type find many API response body */
  ERP_1C_OPERATION_TYPE_PAGE_DTO = 'catalog/erp-1c-operation-type-page.dto',
  /** 1C ERP native operation type synchronize API query parameters */
  ERP_1C_OPERATION_TYPE_SYNC_QUERY_DTO = 'catalog/erp-1c-operation-type-sync-query.dto',
  /** Webhook response body */
  WEBHOOK_FIND_DTO = 'catalog/webhook-find.dto',
  /** Webhook create and update APIs request body */
  WEBHOOK_FORM_DTO = 'catalog/webhook-form.dto',
  /** Agent filter query parameters */
  AGENT_FILTERS_DTO = 'catalog/agent-filters.dto',
  /** Agent response body */
  AGENT_FIND_DTO = 'catalog/agent-find.dto',
  /** Agent create/update request body */
  AGENT_FORM_DTO = 'catalog/agent-form.dto',
  /** Agent partial update request body */
  AGENT_PARTIAL_FORM_DTO = 'catalog/agent-partial-form.dto',
  /** Agent list page response body */
  AGENT_PAGE_DTO = 'catalog/agent-page.dto',
  /** Agent list API query parameters */
  AGENT_QUERY_DTO = 'catalog/agent-query.dto',
  /** Agent column selection parameters */
  AGENT_SELECT_DTO = 'catalog/agent-select.dto',
  /** Agent sorting settings */
  AGENT_SORT_DTO = 'catalog/agent-sort.dto',
  /** Agent registry items page response body */
  AGENT_ITEMS_PAGE_DTO = 'catalog/agent-items-page.dto',
  /** Knowledge base response body */
  KNOWLEDGE_BASE_FIND_DTO = 'catalog/knowledge-base-find.dto',
  /** Knowledge base create/update request body */
  KNOWLEDGE_BASE_FORM_DTO = 'catalog/knowledge-base-form.dto',
  /** Knowledge base partial update request body */
  KNOWLEDGE_BASE_PARTIAL_FORM_DTO = 'catalog/knowledge-base-partial-form.dto',
  /** Knowledge base list page response body */
  KNOWLEDGE_BASE_PAGE_DTO = 'catalog/knowledge-base-page.dto',
  /** Knowledge base list API query parameters */
  KNOWLEDGE_BASE_QUERY_DTO = 'catalog/knowledge-base-query.dto',
  /** Knowledge base filter query parameters */
  KNOWLEDGE_BASE_FILTERS_DTO = 'catalog/knowledge-base-filters.dto',
  /** Knowledge base column selection parameters */
  KNOWLEDGE_BASE_SELECT_DTO = 'catalog/knowledge-base-select.dto',
  /** Knowledge base sorting settings */
  KNOWLEDGE_BASE_SORT_DTO = 'catalog/knowledge-base-sort.dto',
  /** Knowledge base registry items page response body */
  KNOWLEDGE_BASE_ITEMS_PAGE_DTO = 'catalog/knowledge-base-items-page.dto',
  /** Document file template response body */
  DOCUMENT_FILE_TEMPLATE_FIND_DTO = 'catalog/document-file-template-find.dto',
  /** Document file template create/update API request body */
  DOCUMENT_FILE_TEMPLATE_FORM_DTO = 'catalog/document-file-template-form.dto',
  /** Document file template partial update API request body */
  DOCUMENT_FILE_TEMPLATE_PARTIAL_FORM_DTO = 'catalog/document-file-template-partial-form.dto',
  /** Document file template find many API query parameters */
  DOCUMENT_FILE_TEMPLATE_FIND_MANY_QUERY_DTO = 'catalog/document-file-template-find-many-query.dto',
  /** Document file template find one API query parameters */
  DOCUMENT_FILE_TEMPLATE_FIND_ONE_QUERY_DTO = 'catalog/document-file-template-find-one-query.dto',
  /** Document file template find many API response body */
  DOCUMENT_FILE_TEMPLATE_PAGE_DTO = 'catalog/document-file-template-page.dto',
  /** Document file template selection settings */
  DOCUMENT_FILE_TEMPLATE_SELECT_DTO = 'catalog/document-file-template-select.dto',
  /** Document file template sorting settings */
  DOCUMENT_FILE_TEMPLATE_SORT_DTO = 'catalog/document-file-template-sort.dto',
  /** Document file template filter query parameters */
  DOCUMENT_FILE_TEMPLATE_FILTERS_DTO = 'catalog/document-file-template-filters.dto',
  /** Document file template request parameter */
  DOCUMENT_FILE_TEMPLATE_PARAM_DTO = 'catalog/document-file-template-param.dto',
  /** Document file template key response body */
  DOCUMENT_FILE_TEMPLATE_KEY_FIND_DTO = 'catalog/document-file-template-key-find.dto',
  /** Document file template key brief nested response */
  DOCUMENT_FILE_TEMPLATE_KEY_BRIEF_FIND_DTO = 'catalog/document-file-template-key-brief-find.dto',
  /** Document file template key create/update API request body */
  DOCUMENT_FILE_TEMPLATE_KEY_FORM_DTO = 'catalog/document-file-template-key-form.dto',
  /** Document file template key partial update API request body */
  DOCUMENT_FILE_TEMPLATE_KEY_PARTIAL_FORM_DTO = 'catalog/document-file-template-key-partial-form.dto',
  /** Document file template key find many API query parameters */
  DOCUMENT_FILE_TEMPLATE_KEY_FIND_MANY_QUERY_DTO = 'catalog/document-file-template-key-find-many-query.dto',
  /** Document file template key find one API query parameters */
  DOCUMENT_FILE_TEMPLATE_KEY_FIND_ONE_QUERY_DTO = 'catalog/document-file-template-key-find-one-query.dto',
  /** Document file template key find many API response body */
  DOCUMENT_FILE_TEMPLATE_KEY_PAGE_DTO = 'catalog/document-file-template-key-page.dto',
  /** Document file template key selection settings */
  DOCUMENT_FILE_TEMPLATE_KEY_SELECT_DTO = 'catalog/document-file-template-key-select.dto',
  /** Document file template key sorting settings */
  DOCUMENT_FILE_TEMPLATE_KEY_SORT_DTO = 'catalog/document-file-template-key-sort.dto',
  /** Document file template key filter query parameters */
  DOCUMENT_FILE_TEMPLATE_KEY_FILTERS_DTO = 'catalog/document-file-template-key-filters.dto',
  /** Document file template key target tree response body */
  DOCUMENT_FILE_TEMPLATE_KEY_TARGET_TREE_FIND_DTO = 'catalog/document-file-template-key-target-tree-find.dto',
  /** Document file template key target children response body */
  DOCUMENT_FILE_TEMPLATE_KEY_TARGET_CHILDREN_FIND_DTO = 'catalog/document-file-template-key-target-children-find.dto',
  /** Document file template key numeric source key candidates API query */
  DOCUMENT_FILE_TEMPLATE_KEY_NUMERIC_SOURCE_KEY_CANDIDATES_QUERY_DTO =
    'catalog/document-file-template-key-numeric-source-key-candidates-query.dto',
  /** Document file template log response body */
  DOCUMENT_FILE_TEMPLATE_LOG_FIND_DTO = 'catalog/document-file-template-log-find.dto',
  /** Document file template log create/update API request body */
  DOCUMENT_FILE_TEMPLATE_LOG_FORM_DTO = 'catalog/document-file-template-log-form.dto',
  /** Document file template log partial update API request body */
  DOCUMENT_FILE_TEMPLATE_LOG_PARTIAL_FORM_DTO = 'catalog/document-file-template-log-partial-form.dto',
  /** Document file template log find many API query parameters */
  DOCUMENT_FILE_TEMPLATE_LOG_FIND_MANY_QUERY_DTO = 'catalog/document-file-template-log-find-many-query.dto',
  /** Document file template log find one API query parameters */
  DOCUMENT_FILE_TEMPLATE_LOG_FIND_ONE_QUERY_DTO = 'catalog/document-file-template-log-find-one-query.dto',
  /** Document file template log find many API response body */
  DOCUMENT_FILE_TEMPLATE_LOG_PAGE_DTO = 'catalog/document-file-template-log-page.dto',
  /** Document file template log selection settings */
  DOCUMENT_FILE_TEMPLATE_LOG_SELECT_DTO = 'catalog/document-file-template-log-select.dto',
  /** Document file template log sorting settings */
  DOCUMENT_FILE_TEMPLATE_LOG_SORT_DTO = 'catalog/document-file-template-log-sort.dto',
  /** Document file template log filter query parameters */
  DOCUMENT_FILE_TEMPLATE_LOG_FILTERS_DTO = 'catalog/document-file-template-log-filters.dto',
  /** Document file template list page query (templates + keys modes) */
  DOCUMENT_FILE_TEMPLATE_LIST_QUERY_DTO = 'catalog/document-file-template-list-query.dto',
  /** Document file template list mode fields (group / select* / sort*) */
  DOCUMENT_FILE_TEMPLATE_LIST_MODE_FIELDS_DTO = 'catalog/document-file-template-list-mode-fields.dto',
  /** Document file template registry selectable item (templates mode) */
  DOCUMENT_FILE_TEMPLATE_REGISTRY_SELECTABLE_ITEM_DTO = 'catalog/document-file-template-registry-selectable-item.dto',
  /** Document file template key registry selectable item (keys mode) */
  DOCUMENT_FILE_TEMPLATE_KEY_REGISTRY_SELECTABLE_ITEM_DTO = 'catalog/document-file-template-key-registry-selectable-item.dto',
  /** Document file template key general response body */
  DOCUMENT_FILE_TEMPLATE_KEY_GENERAL_FIND_DTO = 'catalog/document-file-template-key-general-find.dto',
  /** Other financial own filters */
  OTHER_FINANCIAL_FLOW_FILTERS_DTO = 'catalog/other-financial-flow-filters.dto',
  /** Other financial flow find many API query parameters */
  OTHER_FINANCIAL_FLOW_FIND_MANY_QUERY_DTO = 'catalog/other-financial-flow-find-many-query.dto',
  /** Other financial flow find one API query parameters */
  OTHER_FINANCIAL_FLOW_FIND_ONE_QUERY_DTO = 'catalog/other-financial-flow-find-one-query.dto',
  /** Other financial flow response body */
  OTHER_FINANCIAL_FLOW_FIND_DTO = 'catalog/other-financial-flow-find.dto',
  /** Other financial flow find many API response body */
  OTHER_FINANCIAL_FLOW_PAGE_DTO = 'catalog/other-financial-flow-page.dto',
  /** Other financial flow selection settings */
  OTHER_FINANCIAL_FLOW_SELECT_DTO = 'catalog/other-financial-flow-select.dto',
  /** Other financial flow sorting settings */
  OTHER_FINANCIAL_FLOW_SORT_DTO = 'catalog/other-financial-flow-sort.dto',
  /** Warehouse response body */
  WAREHOUSE_FIND_DTO = 'catalog/warehouse-find.dto',
  /** Warehouse selection settings */
  WAREHOUSE_SELECT_DTO = 'catalog/warehouse-select.dto',
  /** Warehouse sorting settings */
  WAREHOUSE_SORT_DTO = 'catalog/warehouse-sort.dto',
  /** Warehouse find many API query parameters */
  WAREHOUSE_FIND_MANY_QUERY_DTO = 'catalog/warehouse-find-many-query.dto',
  /** Warehouse find many API response body */
  WAREHOUSE_PAGE_DTO = 'catalog/warehouse-page.dto',
  /** Warehouse find one API query parameters */
  WAREHOUSE_FIND_ONE_QUERY_DTO = 'catalog/warehouse-find-one-query.dto',
  /** Warehouse own filters */
  WAREHOUSE_FILTERS_DTO = 'catalog/warehouse-filters.dto',
  /** CostItem response body */
  COST_ITEM_FIND_DTO = 'catalog/cost-item-find.dto',
  /** CostItem selection settings */
  COST_ITEM_SELECT_DTO = 'catalog/cost-item-select.dto',
  /** CostItem sorting settings */
  COST_ITEM_SORT_DTO = 'catalog/cost-item-sort.dto',
  /** CostItem find many API query parameters */
  COST_ITEM_FIND_MANY_QUERY_DTO = 'catalog/cost-item-find-many-query.dto',
  /** CostItem find many API response body */
  COST_ITEM_PAGE_DTO = 'catalog/cost-item-page.dto',
  /** CostItem find one API query parameters */
  COST_ITEM_FIND_ONE_QUERY_DTO = 'catalog/cost-item-find-one-query.dto',
  /** CostItem own filters */
  COST_ITEM_FILTERS_DTO = 'catalog/cost-item-filters.dto',
  /** CashFlowItem response body */
  CASH_FLOW_ITEM_FIND_DTO = 'catalog/cash-flow-item-find.dto',
  /** CashFlowItem selection settings */
  CASH_FLOW_ITEM_SELECT_DTO = 'catalog/cash-flow-item-select.dto',
  /** CashFlowItem sorting settings */
  CASH_FLOW_ITEM_SORT_DTO = 'catalog/cash-flow-item-sort.dto',
  /** CashFlowItem find many API query parameters */
  CASH_FLOW_ITEM_FIND_MANY_QUERY_DTO = 'catalog/cash-flow-item-find-many-query.dto',
  /** CashFlowItem find many API response body */
  CASH_FLOW_ITEM_PAGE_DTO = 'catalog/cash-flow-item-page.dto',
  /** CashFlowItem find one API query parameters */
  CASH_FLOW_ITEM_FIND_ONE_QUERY_DTO = 'catalog/cash-flow-item-find-one-query.dto',
  /** CashFlowItem own filters */
  CASH_FLOW_ITEM_FILTERS_DTO = 'catalog/cash-flow-item-filters.dto',
}
